/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LanguageCommunicationPreference
 */
export interface LanguageCommunicationPreference {
    /**
     * 
     * @type {string}
     * @memberof LanguageCommunicationPreference
     */
    language: string;
}

/**
 * Check if a given object implements the LanguageCommunicationPreference interface.
 */
export function instanceOfLanguageCommunicationPreference(value: object): value is LanguageCommunicationPreference {
    if (!('language' in value) || value['language'] === undefined) return false;
    return true;
}

export function LanguageCommunicationPreferenceFromJSON(json: any): LanguageCommunicationPreference {
    return LanguageCommunicationPreferenceFromJSONTyped(json, false);
}

export function LanguageCommunicationPreferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LanguageCommunicationPreference {
    if (json == null) {
        return json;
    }
    return {
        
        'language': json['language'],
    };
}

export function LanguageCommunicationPreferenceToJSON(value?: LanguageCommunicationPreference | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'language': value['language'],
    };
}

